module.exports = __webpack_public_path__ + "img/pdf.a7d6d970.png";